import {
    formSearchFieldAction,
    formOpenSearchField,
    formSearchNextPage
} from '../services/fieldSearch';
import {
    setIsForceSendValueToServer,
    formZoom,
    getIsForceSendValueToServer,
    addChooseStateXml,
    pasteColumn
} from '../../../_shared/GWTBridge/invoke/netForm';
import {setActiveInputValue} from '../../../_shared/GWTBridge/invoke/priTextBox';
import {zoomModes} from '../consts/zoomModes';
import {multiSearchDeserialize} from '../serializes/fieldSearch';
import {getSortOption} from '../utils/sort';

export function saveChooseState(sortBy, isDesc, chooseId) {
    const sortOption = getSortOption(sortBy, isDesc);
    addChooseStateXml(sortOption, chooseId);
}

/**
 * if isSearch === false,
 * a Search OR a Choose will be opened according to the data received form the server;
 * if isSearch === true,
 * a Search will be opened
 *  */
export function openFormSearch(isSearch = false) {
    const isForceSendValueToServer = getIsForceSendValueToServer();
    return formOpenSearchField(isSearch).then((result: any) => {
        setIsForceSendValueToServer(isForceSendValueToServer);
        if (result.Form[0].Search) {
            return result.Form[0].Search[0];
        }
        if (result.Form[0].Choose) {
            return result.Form[0].Choose[0];
        }
        if (result.Form[0].Zoom) {
            return result.Form[0].Zoom[0];
        }
        if (result.Form[0].Error?.length) {
            return result.Form[0].Error[0];
        }
        return {};
    });
}

export function formSearch(searchAction, val) {
    return formSearchFieldAction(searchAction, val).then((result: any) => {
        return result.Form[0].Search ? result.Form[0].Search[0] : {};
    });
}

export function formSearchNext(page, val) {
    return formSearchNextPage(page, val).then((result: any) => {
        return result.Form[0].Search ? result.Form[0].Search[0] : {};
    });
}

export function setInputValue(value, params) {
    setActiveInputValue(value, params.isAutocomplete);
}

export function setMultiSelectValues(values) {
    if (values.length === 1) {
        setActiveInputValue(values[0], false);
    } else if (values.length > 1) {
        const pasteData = multiSearchDeserialize(values);
        pasteColumn(pasteData);
    }
}

export function zoomToNewEntry() {
    formZoom(zoomModes.addNew);
}

export function zoomToAdvancedSearch() {
    formZoom(zoomModes.advancedSearch);
}

export function zoomToFieldValue() {
    formZoom(zoomModes.fieldValue);
}
